import React from "react"; // Required for JSX even if not explicitly used
import { Label } from './ui/label';
import { Switch } from './ui/switch';

interface ToggleSettingRowProps {
  label: string;
  id: string;
  checked: boolean;
  onCheckedChange: (checked: boolean) => void;
}

export default function ToggleSettingRow({ label, id, checked, onCheckedChange }: ToggleSettingRowProps) {
  return (
    <div className="flex items-center justify-between border-b border-[color:var(--jr-border)] bg-transparent px-4 py-4">
      <Label htmlFor={id} className="flex-grow cursor-pointer text-base text-[var(--jr-text)]">{label}</Label>
      <Switch id={id} checked={checked} onCheckedChange={onCheckedChange} className="data-[state=checked]:bg-[color:var(--jr-accent-strong)] data-[state=unchecked]:bg-[color:var(--jr-surface-muted)]" />
    </div>
  );
}
